/* dev-wellness-timeline.js
   Drives the mobile carousel progress bar: the thumb width reflects how much of
   the track is visible, and its position reflects the scroll offset. Each
   section instance is wired independently. */

(function () {
  function initTimeline(root) {
    const track = root.querySelector('[data-wt-track]');
    const progress = root.querySelector('[data-wt-progress]');
    const thumb = root.querySelector('[data-wt-thumb]');
    if (!track || !progress || !thumb) return;

    let frame = null;

    function render() {
      frame = null;
      const max = track.scrollWidth - track.clientWidth;
      const trackWidth = progress.clientWidth;
      if (!trackWidth) return;

      if (max <= 1) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      const visibleRatio = track.clientWidth / track.scrollWidth;
      const thumbWidth = Math.max(trackWidth * visibleRatio, 24);
      const offset = (trackWidth - thumbWidth) * (track.scrollLeft / max);

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + Math.round(offset) + 'px)';
    }

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(render);
    }

    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    render();
  }

  function init() {
    document.querySelectorAll('[data-wellness-timeline]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
